<template>
    <section>
        <h1 class="mt-5 mb-3 text-center">{{$t('subjects.header')}}</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        :label="$t('global.search')"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="SUBJECTS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 lessons" :to="{name : 'Lessons', query: {subject_id : props.item.id}}">
                    <svg v-svg="'icon-lesson'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>{{$t('lessons.header')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                keyword: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('subjects.name'), sortable: false, value: 'name'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: mapGetters(['SUBJECTS']),

        mounted(){
            this.getData();
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData();
                }, 300);
            }
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_SUBJECTS', {params: {keyword: this.keyword}})
                    .then(() => this.loadingRequest = false);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Subjects/index";
</style>